import { IOrderNew } from 'my-poppies-b2b-types';

import { timestampMockHelpers } from '@/utils/timestampMockHelpers';

export const dummyDataOrdersNew: IOrderNew[] = [
  {
    userRole: 'EVA',
    id: 'first-new-order',
    createdBy: 'EVA',
    createdAt: timestampMockHelpers.now,
    updatedBy: 'EVA',
    updatedAt: timestampMockHelpers.now,
    sender: 'SOME_SENDER',
    priority: 'HIGH',
    customerId: 'customer-0',
    customerPretty: 'Customer Name Pretty',
    status: 'NEW',
    positions: [
      { positionId: 'kleine-kapseln-40g', amount: 123 },
      { positionId: 'große-kapseln-120g', amount: 14 },
    ],
  },
  {
    userRole: 'EVA',
    id: 'second-new-order',
    sender: 'SOME_SENDER',
    priority: 'LOW',
    createdBy: 'SAM',
    createdAt: timestampMockHelpers.now,
    updatedBy: 'SAM',
    updatedAt: timestampMockHelpers.now,
    customerId: 'customer-1',
    customerPretty: 'Customer Name Pretty',
    status: 'NEW',
    positions: [{ positionId: 'palette-800-100', amount: 17 }],
  },
];
